export enum AgentsSecretsHost {
  MatillionHosted = 'MATILLION',
  CustomerHosted = 'CUSTOMER'
}
